import Utils from "common/utils";
import Constants from 'common/constants'

const WEATHER_BASE_URL = "https://weatherport.co"
const WEATHER_EP = "/apps/getWeatherData"
const WEATHER_DEVICE_LOCATIONS_BASE_URL = "https://weatheport-service-blbgy5bisa-ue.a.run.app"

const PROD_FUNCTION_BASE_URL = "https://us-central1-weather-99fe5.cloudfunctions.net"
const FUNCTION_BASE_URL = "https://us-central1-weather-app-e2373.cloudfunctions.net"


const US_ZIP_CODE_TO_CITY_EP = "/GetUSCityFromPostalCode"
const GEO_DATA_EP = "/GetCurrGeoCode"
const LOC_SUGG_EP = "/GetLocationSuggestions"
const SELECTED_LOC_EP = "/deviceLocation"
class UrlManager {
    getWeatherEndpoint() {
        return `${WEATHER_BASE_URL}${WEATHER_EP}`
    }

    getZipCodeToCityEndpoint() {
        return `${this.getFunctionUrl()}${US_ZIP_CODE_TO_CITY_EP}`
    }

    getIpGeoEndpoint() {
        return `${this.getFunctionUrl()}${GEO_DATA_EP}`
    }

    getLocationSuggestionEndpoint() {
        return `${this.getFunctionUrl()}${LOC_SUGG_EP}`
    }

    getSelectedLocationsEndpoint() {
        return `${WEATHER_DEVICE_LOCATIONS_BASE_URL}${SELECTED_LOC_EP}`
    }

    getFunctionUrl() {
        let env = process.env.REACT_APP_DEPLOY_ENV
        if (false === Utils.isNull(env) && env === Constants.ENV.INTERNAL) {
            return FUNCTION_BASE_URL
        }
        return PROD_FUNCTION_BASE_URL
    }
}

let instance = new UrlManager()
export default instance



// WEBPACK FOOTER //
// ./src/manager/urlManager.js